import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import { Logger } from 'fsts';
import { SearchParams } from '../model/searchParams';
import { DefaultBackendHelper } from '../utils/backendHelper';
import documentType, { DocumentType, Value } from '../model/documentType';
import ODataFilterBuilder from 'odata-filter-builder';
import { CONST } from '@/shared/utils/Constants';
import { EntraJobsFacetSearchData } from '../model/smallPayloadModels/entrajobsSearchData';

const logger = new Logger('backend.job');
const searchableColumns: Map<string, string> = new Map([
  ['Entity', 'entity_id'],
  ['Name', 'job_name'],
]);
const defaultOrSearchFields = ['action', 'job_name', 'entity_id'];
export interface EntraJobsType {
  updateUsersFromEntra(): AxiosPromise<any>;
  syncLocalContactsWithAzureUsers(): AxiosPromise<any>;
  syncLocalGroupsAndMembersWithAzure(): AxiosPromise<any>;
  getSharepointGroupsMembers(): AxiosPromise<any>;
  syncSharepointGroups(data: any): AxiosPromise<any>;
  updateEntraJobInterval(data: any): AxiosPromise<any>;
  getEntraGroupsWithMembers(): AxiosPromise<any>;

  getVmeApiUsers(): AxiosPromise<any>;
  updateConditionFromVmeApiUsersTable(): AxiosPromise<any>;

  deleteSharepointTestUser(): AxiosPromise<any>;

  copyTestUserInSyncTable(): AxiosPromise<any>;

  zrPortalFullScanForZrMaster(): AxiosPromise<any>;

  getLastJobTime(): AxiosPromise<any>;
  getAllEntraJobs(): AxiosPromise<any>;
  getJobsNameList(data: any): AxiosPromise<any>;
  getEntityList(data: any): AxiosPromise<any>;
  getListAction(data: any): AxiosPromise<any>;
  getJobDetailLogs(searchParams: SearchParams, searchData?: any): AxiosPromise<Value>;
  getEntraJobsFacetSearch: (facetSearch: EntraJobsFacetSearchData) => AxiosPromise<Value>;
}

export const defaultBackendEntraJobs: EntraJobsType = {
  updateUsersFromEntra(): AxiosPromise<any> {
    logger.debug('updateUsersFromEntra');
    return instance.get(`${URLS.entraJobs}/updateUsersFromEntra`);
  },
  syncLocalContactsWithAzureUsers(): AxiosPromise<any> {
    logger.debug('SyncLocalContactsWithAzureUsers');
    return instance.get(`${URLS.entraJobs}/SyncLocalContactsWithAzureUsers`);
  },
  syncLocalGroupsAndMembersWithAzure(): AxiosPromise<any> {
    logger.debug('syncLocalGroupsAndMembersWithAzure');
    return instance.get(`${URLS.entraJobs}/syncLocalGroupsAndMembersWithAzure`);
  },
  getSharepointGroupsMembers(): AxiosPromise<any> {
    logger.debug('getSharepointGroupsMembers');
    return instance.get(`${URLS.entraJobs}/getSharepointGroupsMembers`);
  },
  syncSharepointGroups(data: any): AxiosPromise<any> {
    logger.debug('syncSharepointGroups');
    return instance.put(`${URLS.entraJobs}/syncSharepointGroups`, data);
  },
  updateEntraJobInterval(data: any): AxiosPromise<any> {
    logger.debug('UpdateEntraJobInterval');
    return instance.put(`${URLS.entraJobs}/UpdateEntraJobInterval`, data);
  },
  getEntraGroupsWithMembers(): AxiosPromise<any> {
    logger.debug('getEntraGroupsWithMembers');
    return instance.get(`${URLS.entraJobs}/getEntraGroupsWithMembers`);
  },
  getVmeApiUsers(): AxiosPromise<any> {
    logger.debug('GetVmeApiUsers');
    return instance.get(`${URLS.entraJobs}/GetVmeApiUsers`);
  },
  updateConditionFromVmeApiUsersTable(): AxiosPromise<any> {
    logger.debug('updateConditionFromVmeApiUsersTable');
    return instance.get(`${URLS.entraJobs}/updateConditionFromVmeApiUsersTable`);
  },

  deleteSharepointTestUser(): AxiosPromise<any> {
    logger.debug('deleteSharepointTestUser');
    return instance.get(`${URLS.entraJobs}/deleteSharepointTestUser`);
  },
  copyTestUserInSyncTable(): AxiosPromise<any> {
    logger.debug('copyTestUserInSyncTable');
    return instance.get(`${URLS.entraJobs}/CopyVmeTestUsersInTblSyncTable`);
  },

  zrPortalFullScanForZrMaster(): AxiosPromise<any> {
    logger.debug('zrPortalFullScanForZrMaster');
    return instance.get(`${URLS.entraJobs}/ZrPortalFullScanForZrMaster`);
  },

  getLastJobTime(): AxiosPromise<any> {
    logger.debug('getLastJobTime');
    return instance.get(`${URLS.entraJobs}/getLastJobTime`);
  },
  getJobsNameList(data: any): AxiosPromise<any> {
    logger.debug('getJobsNameList');
    return instance.post(`${URLS.entraJobs}/GetJobsNameList`, data);
  },
  getEntityList(data: any): AxiosPromise<any> {
    logger.debug('getEntityList');
    return instance.post(`${URLS.entraJobs}/GetEntityList`, data);
  },
  getListAction(data: any): AxiosPromise<any> {
    logger.debug('getListAction');
    return instance.post(`${URLS.entraJobs}/GetListAction`, data);
  },
  getJobDetailLogs(searchParams: any, searchData?: any): AxiosPromise<Value> {
    var odfb = ODataFilterBuilder('and');
    if (searchParams.andClauseFieldsIds?.length > 0) {
      if (!searchParams.andClauseFieldsIds?.some((x: any) => x.chipField == 'all')) {
        searchParams.orClauseFieldsIds = [];
      } else {
        let allChipField = searchParams.andClauseFieldsIds?.find((x: any) => x.chipField == 'all');
        searchParams.filter = allChipField.searchWord;
        searchParams.orClauseFieldsIds = defaultOrSearchFields;
      }
      let andClauseFieldsIds: Array<any> = searchParams.andClauseFieldsIds;

      andClauseFieldsIds.forEach((element: any, index: number) => {
        const chipField = searchableColumns.has(element.chipField)
          ? searchableColumns.get(element.chipField)
          : element.chipField;
        if (element.chipField == 'all') {
          // do nothing
        } else {
          odfb.contains(`tolower(${chipField})`, element.searchWord.toLowerCase());
          //odfb.startsWith(`tolower(${chipField})`, element.searchWord.toLowerCase());
        }
      });
    }

    let url = DefaultBackendHelper.makeUrl(
      `${URLS.entraJobsnOdata}`,
      searchParams.dataOption,
      searchParams.orClauseFieldsIds,
      searchParams.filter,
      odfb
    );

    return instance.put<Value>(url, searchData);
  },
  getEntraJobsFacetSearch(facetData: EntraJobsFacetSearchData): AxiosPromise<any> {
    let url = `${URLS.entraJobs}/GetSearchResult`;
    return instance.put<Value>(url, facetData);
  },
  getAllEntraJobs(): AxiosPromise<any> {
    logger.debug('getAllEntraJobs');
    return instance.get(`${URLS.entraJobs}/GetAllEntraJobs`);
  },
};
